<template>
  <div>
    <PreviewEntrance v-if="!isUpdate" @updateEvent="updateEvent" />
    <UpdateEntrance v-else @updateEvent="updateEvent" />
    <ScrollTopBtn />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import './entrance.scss';
import { masterMixin } from '@/mixins/masterMixin.js';
import PreviewEntrance from './PreviewEntrance';
import UpdateEntrance from './UpdateEntrance';
import ScrollTopBtn from '@/components/ScrollTopBtn';

export default {
  mixins: [masterMixin],
  data: () => {
    return {
      isUpdate: false
    };
  },
  components: {
    PreviewEntrance,
    UpdateEntrance,
    ScrollTopBtn
  },
  computed: {
    ...mapGetters({
      applicant_entry: 'getEntryInfomation'
    })
  },
  methods: {
    updateEvent() {
      this.isUpdate = !this.isUpdate;
    }
  }
};
</script>

<style></style>
